import React from "react";
import {Control} from "react-hook-form/dist/types";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Controller, FieldPath} from "react-hook-form";
import {ProvinciaRecord} from "@commons/mapping/ProvinciaRecord";
import {useGetProvinceQuery} from "@commons/features/sistema/ComuniEProv.api";
import ComboBox from "./ComboBox";

export const ComboBoxProvince: React.FC<{
    control: Control<AziendaRecord>,
    name: FieldPath<AziendaRecord>,
    defaultValue: string,
    onChange?: (v: ProvinciaRecord | null) => void
}> = ({control, name, defaultValue, onChange}) => {
    const {data, isLoading} = useGetProvinceQuery();
    const onChangeProvincia = onChange ? onChange : (v: ProvinciaRecord | null) => {
    };
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={{required: true}}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<ProvinciaRecord> label={'Provincia'} value={{siglaProv: value}} onChange={(v) => {
                                   onChange(v?.siglaProv)
                                   onChangeProvincia(v);
                               }} fieldState={fieldState}
                                                          data={data}
                                                          isLoading={isLoading}

                                                          searchablePropsName={['siglaProv', 'descrizione']}
                                                          isSameFn={(a, z) => (a && z) ? a.siglaProv === z.siglaProv : false}
                                                          keyValueFn={(v) => v.siglaProv!}
                                                          displayValueFn={(v) => data && v ? v.descrizione! + ' (' + v.siglaProv + ')' : ''}
                               />
                           )
                       }}
    />
}
export default ComboBoxProvince;